import { createAsyncThunk, createSlice, isFulfilled } from '@reduxjs/toolkit';
import axios from 'axios';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { PasswordSlice, savePassword } from 'app/modules/account/password/password.reducer';
import { AppThunk, useAppDispatch } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';

const initialState = {
  loading: false,
  errorMessage: null,
  successMessage: null,
  updateSuccess: false,
  updateFailure: false,
};

export type ApiKeyState = Readonly<typeof initialState>;

// export const changeApiKey: () => AppThunk = () => async dispatch => {
//   await dispatch(changeKey)
//   dispatch(getSession)
// }

export const changeApiKey = createAsyncThunk('api-key/change', async () => axios.post('/api/account/change-api-key'), {
  serializeError: serializeAxiosError,
});

export const ApiKeySlice = createSlice({
  name: 'apiKey',
  initialState: initialState as ApiKeyState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(changeApiKey.pending, state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addCase(changeApiKey.rejected, state => {
        state.loading = false;
        state.updateSuccess = false;
        state.updateFailure = true;
        state.errorMessage = 'An error has occurred! The api key could not be changed.';
      })
      .addMatcher(isFulfilled(changeApiKey), (state, action) => {
        return {
          ...state,
          loading: false,
          updateSuccess: true,
          updateFailure: false,
          successMessage: 'Api Key changed!',
        };
      });
  },
});

export const { reset } = PasswordSlice.actions;

export default ApiKeySlice.reducer;
